import React from 'react';

import { Button } from '@pkg/components';
import { Wrapper } from '@pkg/components/DesignSystem';
import { useGetEmojiGroups, useMutateEmojiGroup } from '@pkg/hooks/admin/emoji/groups';

import { type EmojiGroupCheckResponse, type EmojiGroupsAction } from '@app/client';
import { decimals } from '@app/helpers';

import { StyledCell, StyledHeader, StyledRow, StyledTable } from './AdminEmojiGroups.style';

export function AdminEmojiPatterns({ serverMatch }: { serverMatch?: EmojiGroupCheckResponse }) {
    const { groups } = useGetEmojiGroups(); // TODO add pagination
    const { deleteGroup } = useMutateEmojiGroup();

    const sortedGroups = groups?.sort((a, b) => (b?.rank || 0) - (a?.rank || 0));
    function renderAction(action?: EmojiGroupsAction) {
        if (!action) {
            return <p>Reserved</p>;
        } else if (typeof action === 'string') {
            return <p>{action}</p>;
        } else {
            if (action.Reserve) {
                return (
                    <p>
                        Reserved until <strong>{action.Reserve?.onsale_from?.toString()}</strong>
                    </p>
                );
            } else if (action.Price) {
                return <p>{`On sale with price: $${decimals(action.Price.price_in_cents / 100)} / year`}</p>;
            }
        }
    }

    return (
        <Wrapper>
            <StyledTable>
                <StyledRow>
                    <StyledHeader>Pattern</StyledHeader>
                    <StyledHeader>Action</StyledHeader>
                    <StyledHeader>Match</StyledHeader>
                    <StyledHeader>Tags</StyledHeader>
                    <StyledHeader>Rank</StyledHeader>
                    <StyledHeader>&nbsp;</StyledHeader>
                </StyledRow>
                {sortedGroups?.map((g) => {
                    const hasServerMatch = serverMatch && serverMatch.group && serverMatch.group.id === g.id;
                    return (
                        <StyledRow key={g.id} $hasServerMatch={hasServerMatch}>
                            <StyledCell> {g.pattern}</StyledCell>
                            <StyledCell>{renderAction(g.action)}</StyledCell>
                            <StyledCell $hasServerMatch={hasServerMatch}>
                                {hasServerMatch ? <span>{serverMatch.eid}</span> : ''}
                            </StyledCell>
                            <StyledCell>
                                <ul className="tag">
                                    {g.tags.map((g) => (
                                        <li key={g}>{g}</li>
                                    ))}
                                </ul>
                            </StyledCell>
                            <StyledCell>{g.rank}</StyledCell>
                            <StyledCell>
                                <Button
                                    onClick={() => deleteGroup({ id: g.id })}
                                    size="xsmall"
                                    color="secondary"
                                    title="Delete group"
                                >
                                    <span role={'img'} aria-label={'Delete Group'}>
                                        ☠️
                                    </span>
                                </Button>
                            </StyledCell>
                        </StyledRow>
                    );
                })}
            </StyledTable>
        </Wrapper>
    );
}
